"use strict";

require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.array.reduce.js");
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/es.number.to-fixed.js");
var _react = _interopRequireWildcard(require("react"));
var _paulCorePackage = require("paul-core-package");
var _constants = require("../utils/constants");
var _function = require("../utils/function");
var _moment = _interopRequireDefault(require("moment/moment"));
var _Charts = require("../components/Charts");
var _reactRedux = require("react-redux");
var _selectors = require("../redux/selectors");
var _LineIcon = require("../components/Legend/LineIcon");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
const {
  getDateFormat
} = _paulCorePackage.functions;
const {
  ComponentTypes
} = _paulCorePackage.constants;
const useGetChartLines = _ref => {
  let {
    chartId,
    equipmentKey,
    hoverLine,
    unCheckedLegend,
    dateType = "",
    rangeType
  } = _ref;
  const [data, setData] = (0, _react.useState)([]);
  const [lines, setLines] = (0, _react.useState)([]);
  const [pipesCount, setPipesCount] = (0, _react.useState)(0);
  const chartData = (0, _reactRedux.useSelector)((0, _selectors.selectChartDataByChartId)(chartId)) || {};
  const activeGroup = (0, _reactRedux.useSelector)((0, _selectors.selectActiveGroup)(chartId));
  const tV = (0, _reactRedux.useSelector)(_paulCorePackage.selectors.getActiveTranslationsValues);
  const TypePipe = equipmentKey === _constants.keysForGroupChartsById.Pwh ? ComponentTypes.PwhPipe : ComponentTypes.HtgPipe;
  const getColor = (0, _react.useCallback)((equipmentType, displayId) => {
    var _tV$Colours;
    if ((_tV$Colours = tV.Colours) !== null && _tV$Colours !== void 0 && (_tV$Colours = _tV$Colours[equipmentType]) !== null && _tV$Colours !== void 0 && _tV$Colours[displayId]) {
      return "#".concat(tV.Colours[equipmentType][displayId]);
    }
    return _constants.defaultLineColor;
  }, [tV]);
  (0, _paulCorePackage.useDeepEffect)(() => {
    if (!_paulCorePackage.functions.isEmpty(chartData) && activeGroup) {
      var _linesData$filter;
      let _PipeCount = 0;
      const linesData = Object.keys(chartData).reduce((accListType, keyType) => [...accListType, ...Object.values(chartData[keyType]).reduce((accListPDId, devicePDIdObj, index) => [...accListPDId, ...Object.values(devicePDIdObj).reduce((accListNameId, displayNameIdObj, devicePDIdObjIndex) => [...accListNameId, ...Object.keys(displayNameIdObj).reduce((acc, keyId) => {
        var _displayNameIdObj$key;
        const id = "".concat(keyType, "_").concat(Object.keys(devicePDIdObj || {})[devicePDIdObjIndex], "_").concat(keyId);
        if (((_displayNameIdObj$key = displayNameIdObj[keyId]) === null || _displayNameIdObj$key === void 0 ? void 0 : _displayNameIdObj$key.length) !== 0) {
          var _ref2, _tV$Default, _tV$keyType;
          const iFirstData = Object.values(displayNameIdObj[keyId]).findIndex(v => v.value);
          const {
            strokeDasharray
          } = _constants.lineSettings[keyType] || _constants.lineSettings.default;
          const color = getColor(keyType, keyId);
          const icon = {
            type: (_ref2 = _constants.lineSettings[keyType] || _constants.lineSettings.default) === null || _ref2 === void 0 ? void 0 : _ref2.type,
            color,
            strokeDasharray
          };
          const textTooltip = "".concat((tV === null || tV === void 0 || (_tV$Default = tV.Default) === null || _tV$Default === void 0 ? void 0 : _tV$Default.equipmentType[keyType]) || keyType, " - ").concat(((_tV$keyType = tV[keyType]) === null || _tV$keyType === void 0 ? void 0 : _tV$keyType.displayNameId[keyId]) || "").concat(keyType === TypePipe ? " ".concat(_PipeCount + 1) : "");
          const tooltip = /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_LineIcon.LineIcon, {
            equipmentType: keyType,
            displayNameId: keyId,
            icon: icon
          }), /*#__PURE__*/_react.default.createElement("span", null, textTooltip));
          if (keyType === TypePipe) _PipeCount++;
          const line = {
            id: id,
            equipmentType: keyType,
            normalColor: getColor(keyType, keyId),
            color,
            icon,
            strokeDasharray,
            displayNameId: keyId,
            title: tooltip,
            data: Object.values(displayNameIdObj[keyId]).reduce((acc, item, index) => iFirstData && index < iFirstData ? acc : [...acc, {
              x: getDateFormat((0, _function.isLastDate)(item, displayNameIdObj[keyId], index) ? (0, _moment.default)(item.date).add(1, _constants.rangeTypesByKey[rangeType]) : (0, _moment.default)(item.date), "YYYY-MM-DD HH:mm").toString(),
              // Temporary solution, while no prediction data!
              // (When will be data, replace it with the bottom line)
              y: item.value ? dateType === _constants.constDateType.month && (0, _moment.default)(item.date).isAfter(_moment.default.now()) ? null : +item.value.toFixed(2) : null
              //y: item.value ? +item.value.toFixed(2) : null
            }], [])
          };
          return [...acc, line];
        } else {
          return acc;
        }
      }, [])], [])], [])], []) || [];
      if (linesData.length) setPipesCount((linesData === null || linesData === void 0 || (_linesData$filter = linesData.filter(line => (line === null || line === void 0 ? void 0 : line.equipmentType) === TypePipe)) === null || _linesData$filter === void 0 ? void 0 : _linesData$filter.length) || 0);
      setData(linesData);
    }
  }, [chartData, activeGroup, rangeType, getColor, TypePipe, tV]);
  (0, _paulCorePackage.useDeepEffect)(() => {
    if (!_paulCorePackage.functions.isEmpty(chartData) && activeGroup.length) {
      const _data = data.map(item => {
        const notHovered = !!hoverLine && !((hoverLine === null || hoverLine === void 0 ? void 0 : hoverLine.equipmentType) === item.equipmentType && ((hoverLine === null || hoverLine === void 0 ? void 0 : hoverLine.equipmentType) === TypePipe ? true : (hoverLine === null || hoverLine === void 0 ? void 0 : hoverLine.displayNameId) === item.displayNameId));
        return _objectSpread(_objectSpread({}, item), {}, {
          color: notHovered ? _Charts._lineTheme.disabledLine : item.normalColor
        });
      });
      setLines(_data.filter(item => !unCheckedLegend.find(l => (l === null || l === void 0 ? void 0 : l.equipmentType) === item.equipmentType && ((l === null || l === void 0 ? void 0 : l.equipmentType) === TypePipe ? true : (l === null || l === void 0 ? void 0 : l.displayNameId) === item.displayNameId))));
    }
  }, [hoverLine, data, unCheckedLegend]);
  return (0, _react.useMemo)(() => ({
    pipesCount,
    lines,
    data
  }), [pipesCount, lines, data]);
};
var _default = exports.default = useGetChartLines;